var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"search"}},[_c('FiltersSearch'),_c('List')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }